import styled from "styled-components";

export const PegDefaultBox = styled.div<{pegIndex: number; totalPegs: number;}>`
    /** create a positioning context for the little peg inside */
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: flex-start;

    width: 100%;
    height: 100%;
    /** TODO: WheelOfJackpotbet: Explain this formula in a comment */
    transform: rotate(${(props) => (props.pegIndex*2+1)*(360/props.totalPegs)/2}deg);
`;
